import { Outlet } from "react-router";
import { PublicFooter } from "@/components/PublicFooter";

export default function PublicPageLayout() {
  return (
    <div className="flex h-fit min-h-full w-full min-w-0 flex-col bg-purple-50/30">
      <div className="w-full min-w-0 flex-1"><Outlet /></div>
      <PublicFooter />
    </div>
  );
}
